<template>
  <div class="container">
    <el-card class="reset-form-card">
      <div slot="header" class="clearfix">
        <span>重置密码</span>
      </div>

      <el-form ref="resetForm" :model="resetForm" label-width="100px">
        <el-form-item label="新密码">
          <el-input type="password" v-model="resetForm.newPassword" placeholder="请输入新密码"></el-input>
        </el-form-item>

        <el-form-item label="确认密码">
          <el-input type="password" v-model="resetForm.confirmPassword" placeholder="请再次输入新密码"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="resetPassword" :loading="loading">重置密码</el-button>
          <router-link tag="el-button" type="text" to="/login">返回登录</router-link>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import api from "api/api";
import {Message} from "element-ui";

export default {
  name: "ResetPassword",
  data() {
    return {
      resetForm: {
        newPassword: '',
        confirmPassword: '',
        token: ''
      },
      loading: false
    };
  },
  created() {
    this.resetForm.token = this.$route.query.token
  },
  methods: {
    async resetPassword() {
      this.loading = true
      try {
        await api.post('/user/reset-password', this.resetForm);
        Message.success("重置密码成功，请重新登录")
        await this.$router.replace('/login')
      } catch (e) {
        Message.error('重置密码错误')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f5f5;
}

.reset-form-card {
  width: 400px;
}
</style>
